import { Component, Mixins } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { AppFiltersMixin } from '@/mixins/AppFiltersMixin';
import { IAflosschemas } from '@/model/IAflosschemas';
import { Chart } from 'highcharts-vue';
import moment from 'moment';

@Component({
  components: {
    highcharts: Chart
  },
  validations: {}
})
export default class AppAflossenHypotheekdeelSchemas extends Mixins(AppFiltersMixin) {
  @State(state => state.aflosschemas)
  public aflosschemas!: IAflosschemas;
  public heleLooptijd = false;

  public get oudeBrutoMaandlast(): number | undefined {
    return (
      this.aflosschemas.voorBetaling &&
      this.aflosschemas.voorBetaling[0].betaaldeRente + this.aflosschemas.voorBetaling[0].betaaldeSchuld
    );
  }

  public get nieuweBrutoMaandlast(): number | undefined {
    return (
      this.aflosschemas.naBetaling &&
      this.aflosschemas.naBetaling[0].betaaldeRente + this.aflosschemas.naBetaling[0].betaaldeSchuld
    );
  }

  public get verschilBrutoMaandlast(): number | undefined {
    const oud = this.oudeBrutoMaandlast;
    const nieuw = oud && this.nieuweBrutoMaandlast;
    return oud && nieuw && oud - nieuw;
  }

  public get oudeHuidigeSchuld(): number | undefined {
    return (
      this.aflosschemas.voorBetaling &&
      this.aflosschemas.voorBetaling[0].restSchuld + this.aflosschemas.voorBetaling[0].betaaldeSchuld
    );
  }

  public get nieuweHuidigeSchuld(): number | undefined {
    return (
      this.aflosschemas.naBetaling &&
      this.aflosschemas.naBetaling[0].restSchuld + this.aflosschemas.naBetaling[0].betaaldeSchuld
    );
  }

  public get verschilHuidigeSchuld(): number | undefined {
    const oud = this.oudeHuidigeSchuld;
    const nieuw = oud && this.nieuweHuidigeSchuld;
    return oud && nieuw && oud - nieuw;
  }

  public get langeLooptijd(): boolean {
    return !!(this.aflosschemas && this.aflosschemas.voorBetaling && this.aflosschemas.voorBetaling.length > 60);
  }

  public get chartOptions(): any {
    // const terms = this.terms || [];
    const tjipCurrency = (this.$options.filters as any).tjipCurrency;
    const size = this.heleLooptijd ? this.aflosschemas.voorBetaling?.length || 360 : 60;
    const labelInterval = Math.floor(Math.floor(size / 12) / 6);
    const heleLooptijd = this.heleLooptijd;
    const categories = this.aflosschemas.voorBetaling?.map(s => new Date(s.datum)).slice(0, size) || [];
    const plotLines: any[] = [];
    categories.forEach((c, pos) => {
      const m = moment(c);
      if (
        m.month() === 0 &&
        (!heleLooptijd || (Math.floor(pos / 12) % labelInterval === 0 && pos < size - 24) || pos > size - 12)
      ) {
        plotLines.push({
          value: pos,
          color: '#e0e0e0',
          dashStyle: 'Solid',
          width: 1
        });
      }
    });
    return {
      chart: {
        type: 'line'
      },
      title: undefined,
      xAxis: {
        categories: categories,
        labels: {
          formatter: function(this: any): string {
            const m = moment(this.value);
            if (
              m.month() === 0 &&
              (!heleLooptijd ||
                (Math.floor(this.pos / 12) % labelInterval === 0 && this.pos < size - 24) ||
                this.pos > size - 12)
            ) {
              return m.format('YYYY');
            }
            return '';
          },
          step: 1
        },
        plotLines: plotLines
      },
      yAxis: {
        title: undefined,
        labels: {
          formatter: function(this: any): string {
            return tjipCurrency(this.value, { maximumFractionDigits: 0 });
          }
        },
        floor: 0
      },
      tooltip: {
        formatter: function(this: any): string {
          const key = moment(this.x).format('MMMM YYYY');
          const value = tjipCurrency(this.y, { maximumFractionDigits: 0 });
          return `<div>${this.series.name}, ${key}: <strong>${value}</strong>`;
        }
      },
      plotOptions: {
        line: {
          marker: {
            enabled: false
          },
          stickyTracking: false
        }
      },
      series: [
        {
          name: 'Huidig aflosschema',
          color: '#1B85FF',
          data: this.aflosschemas.voorBetaling?.map(s => s.restSchuld).slice(0, size)
        },
        {
          name: 'Nieuw aflosschema',
          color: '#77B540',
          data: this.aflosschemas.naBetaling?.map(s => s.restSchuld).slice(0, size)
        }
      ],
      legend: {
        enabled: true
      },
      credits: {
        enabled: false
      }
    };
  }
}
